import { TbCheck } from "react-icons/tb";
import { INTERNAL_TRANSFER_STEPS } from "./constants";

export const InternalTransferStepper = ({ currentStep = 0 }) => (
  <nav aria-label="Etapas da transferência interna" className="mb-3 w-full">
    <ol className="flex w-full items-center">
      {INTERNAL_TRANSFER_STEPS.map((step, index) => {
        const allCompleted = currentStep >= INTERNAL_TRANSFER_STEPS.length;
        const isCompleted = allCompleted || index < currentStep;
        const isActive = !allCompleted && index === currentStep;
        const isLast = index === INTERNAL_TRANSFER_STEPS.length - 1;

        return (
          <li key={step.id} className={`flex items-center ${isLast ? "" : "flex-1"}`}>
            <div className="flex min-w-[2.5rem] flex-col items-center gap-1 sm:min-w-[3.5rem]">
              <div
                className={`flex h-9 w-9 items-center justify-center rounded-full text-xs font-bold transition sm:h-7 sm:w-7 sm:text-[11px] ${
                  isCompleted
                    ? "bg-[#e7a73f] text-white"
                    : isActive
                      ? "border-2 border-[#e7a73f] bg-white text-[#a66f1d]"
                      : "border border-gray-200 bg-white text-gray-400"
                }`}
              >
                {isCompleted ? <TbCheck className="h-4 w-4 sm:h-3.5 sm:w-3.5" /> : index + 1}
              </div>
              <span
                className={`hidden text-center text-[10px] font-semibold sm:block ${
                  isActive || isCompleted ? "text-brand-dark" : "text-gray-400"
                }`}
              >
                {step.label}
              </span>
            </div>
            {!isLast && (
              <div
                className={`mx-1 h-0.5 flex-1 rounded-full sm:mx-1.5 ${
                  isCompleted ? "bg-[#e7a73f]" : "bg-gray-200"
                }`}
              />
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);
